<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Push Nachricht anlegen </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="addForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Typ:</mat-label>
                                <mat-select formControlName="type" (selectionChange)="typeChange()">
                                    <mat-option *ngFor="let sortOption of typesOfPushMessages"
                                        [value]="sortOption.value" [disabled]="sortOption.state">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="submitted &&  addForm.get('type').hasError('required')">
                                    Typ <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

          

                    <div class="row" *ngIf="this.addForm.value.type == 'NEWS'">
                        <div class="col-sm-12">
                            <form class="example-form">
                                <mat-form-field class="full-width">
                                    <mat-label>Verlinkung</mat-label>
                                    <input type="text" matInput [formControl]="myControl" [matAutocomplete]="auto" [disabled]="disablelink">
                                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getOptionTextNEWS" (optionSelected)="setActiveNews($event)">
                                        <mat-option *ngFor="let option of filteredOptions | async"
                                            [value]="option.value">
                                            {{option.viewValue}}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-hint *ngIf="disablelink">
                                        <b>Es sind keine Verlkinungen vorhanden bitte Infobeitrag, Aktion oder Veranstaltung anlegen</b>
                                    </mat-hint>
                                </mat-form-field>
                                <mat-error style="font-size: 12px;margin-top: -19px;margin-bottom: 15px;" *ngIf="submitted &&  addForm.get('eventID').hasError('required')">
                                    Verlinkung <strong>muss</strong> angegeben werden
                                </mat-error>
              
                            </form>
                        </div>
                    </div>

                    <div class="row" *ngIf="this.addForm.value.type == 'APPOINTMENT'">
                        <div class="col-sm-12">
                            <form class="example-form">
                                <mat-form-field class="full-width">
                                    <mat-label>Verlinkung</mat-label>
                                    <input type="text" matInput [formControl]="myControl" [matAutocomplete]="auto">
                                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getOptionTextAPPOINTMENT" (optionSelected)="setActiveAppointments($event)">
                                        <mat-option *ngFor="let option of filteredOptions | async"
                                            [value]="option.value">
                                            {{option.viewValue}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <mat-error style="font-size: 12px;margin-top: -19px;margin-bottom: 15px;" *ngIf="submitted && addForm.get('eventID').hasError('required')">
                                    Verlinkung <strong>muss</strong> angegeben werden
                                </mat-error>
                            </form>
                        </div>
                    </div>

                    <div class="row" *ngIf="this.addForm.value.type == 'EVENTS'">
                        <div class="col-sm-12">
                            <form class="example-form">
                                <mat-form-field class="full-width">
                                    <mat-label>Verlinkung</mat-label>
                                    <input type="text" matInput [formControl]="myControl" [matAutocomplete]="auto" >
                                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getOptionTextEvents" (optionSelected)="setActiveEvents($event)">
                                        <mat-option *ngFor="let option of filteredOptions | async"
                                            [value]="option.value">
                                            {{option.viewValue}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <mat-error style="font-size: 12px;margin-top: -19px;margin-bottom: 15px;" *ngIf="submitted && addForm.get('eventID').hasError('required')">
                                    Verlinkung <strong>muss</strong> angegeben werden
                                </mat-error>
                            </form>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Text:</mat-label>
                                <textarea formControlName="text" matInput rows="8" cols="50"></textarea>
                                <mat-error *ngIf="submitted && addForm.get('text').hasError('required')">
                                    Text <strong>muss</strong> angegeben werden
                                </mat-error>
                                <mat-error *ngIf="submitted && addForm.get('text').hasError('maxlength')">
                                    Maximal 1024 Zeichen
                                </mat-error>
                                <mat-hint>Auf iOS Geräten wird die Nachricht auf ca. 110 Zeichen gekürzt.
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <br>
                    <div class="row">
                        <div class="col-sm-8">
                            <mat-form-field class="full-width">
                                <mat-label>Datum:</mat-label>
                                <input matInput formControlName="date" type="date">
                                <mat-error *ngIf="submitted && addForm.get('date').hasError('required')">
                                    Datum <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Uhrzeit:</mat-label>
                                <input matInput formControlName="time" type="time">
                                <mat-error *ngIf="submitted && addForm.get('time').hasError('required')">
                                    Uhrzeit <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" [routerLink]="['../']">Abbrechen</button>
                    <button mat-button color="primary" (click)="createPush()">Push Anlegen</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>